import { prop, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";

export class ContractOutboundPhone extends Resource {
    public override type = 'contractOutboundPhones';

    @prop()
    @required()
    public contractId!: string;

    @prop()
    @required()
    public phone!: string;
    
    @prop()
    public description?: string;
}
